/**
 * These are the color codes that are not available under our BLUI color package.
 * We are adding them here for better reuse across the application.
 * This file serves as a centralized location for custom color definitions, ensuring consistency and maintainability in our codebase.
 **/

export const BLUISH_WHITE = '#007BC11A';
export const GREENISH_WHITE = '#39B6201A';
export const BLACK500_12_PERCENT = '#424E541F';
